module.exports = __webpack_public_path__ + "static/img/zzjyry.14e198e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/zzjyry.jpg
// module id = vgA/
// module chunks = 21